import React from 'react';
import { PictureTalk2026 } from '../views';

const AccountGeneralPage = () => {
  return <PictureTalk2026 />;
};

export default AccountGeneralPage;
